import { OverflowListCell } from './OverflowListCell';

interface ProvidersCellProps {
  providers: string[];
}

export const ProvidersCell = ({ providers }: ProvidersCellProps) => (
  <OverflowListCell values={providers} />
);
